import { render } from "./JsonFieldTable.vue?vue&type=template&id=390d69d0&scoped=true"
import script from "./JsonFieldTable.vue?vue&type=script&lang=js"
export * from "./JsonFieldTable.vue?vue&type=script&lang=js"

import "./JsonFieldTable.vue?vue&type=style&index=0&id=390d69d0&scoped=true&lang=css"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390d69d0"]])

export default __exports__